import { Modal } from '../../templates/Modal';
import Lock from './index';

interface ILockModal {
  isOpen: boolean;
  onClose: () => void;
}

export default function LockModal({ isOpen, onClose }: ILockModal) {

  return (
    <Modal
      position="center"
      size="sm"
      isOpen={isOpen}
      onClose={() => onClose()}
      className="md:w-2/5 xs:w-full"
    >
      <Lock />
    </Modal>
  );
}
